import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import Casdoor from 'casdoor-vue-sdk'
import 'vue-datepicker-next/index.css'
// import 'leaflet/dist/leaflet.css'

const config = {
    serverUrl: process.env.VUE_APP_SERVER_URL,
    clientId: process.env.VUE_APP_CLIENT_ID,
    organizationName: process.env.VUE_APP_ORG_NAME,
    appName: process.env.VUE_APP_NAME,
    redirectPath: process.env.VUE_APP_REDIRECT_PATH,
    signinPath: process.env.VUE_APP_SIGNIN_PATH,
    scope: process.env.VUE_APP_SCOPE,
}

import dayjs from 'dayjs';
import 'dayjs/locale/id'
import isoWeek from 'dayjs/plugin/isoWeek'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isBetween from 'dayjs/plugin/isBetween'
import duration from 'dayjs/plugin/duration'
dayjs.extend(isoWeek)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(isBetween)
dayjs.extend(duration)
dayjs.locale('id')

createApp(App)
    .use(store)
    .use(router)
    .use(Casdoor, config)
    .use(dayjs)
    .mount('#app')
